import { AfterLoad, Column, Entity, JoinColumn, JoinTable, ManyToOne, OneToMany, Tree, TreeChildren, TreeParent } from 'typeorm';
import { OrderedModel } from '@nsk-app/models/orderedModel';
import { InformationPage } from '@nsk-app/models/informationPage';

@Entity({
  orderBy: {
    order: 'ASC'
  }
})
@Tree('closure-table')
export class InformationCategory extends OrderedModel {
  @Column()
  title: string;

  @TreeParent()
  parent?: InformationCategory;

  @TreeChildren({cascade: true})
  children?: InformationCategory[];

  @OneToMany('InformationPage', (page: InformationPage) => page.category, {eager: true})
  pages?: InformationPage[];

}
